var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Varning';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Varning';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 23.231 20.904',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };